import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface CreateCheckoutSessionInput {
  invoiceId: string;
  organizationId: string;
}

interface CheckoutSessionResult {
  configured: boolean;
  url?: string;
  sessionId?: string;
  paymentLink?: string | null;
}

/**
 * Calls the `stripe-create-checkout-session` edge function.
 *
 * Returns `{ configured: true, url, sessionId }` when Stripe is set up for the
 * org, or `{ configured: false, paymentLink }` when it is not — letting the
 * caller fall back to the saved static Payment Link. Mirrors the pattern of
 * `useSendInvoice` in `useInvoices.ts`.
 */
export function useCreateCheckoutSession() {
  return useMutation({
    mutationFn: async (input: CreateCheckoutSessionInput): Promise<CheckoutSessionResult> => {
      const { data, error } = await supabase.functions.invoke('stripe-create-checkout-session', {
        body: { organizationId: input.organizationId, invoiceId: input.invoiceId },
      });
      if (error) throw error;
      return (data ?? {}) as CheckoutSessionResult;
    },
  });
}
